import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class AdvisorRatingUseCase extends BaseUseCase {
    constructor(advisorRatingDetailsRep) {
        super();
        this.advisorRatingDetailsRep = advisorRatingDetailsRep;
    }
    async fetchResult(req) {
        return await this.advisorRatingDetailsRep.advisorRatingDetailsData(req);
    }
}
export default AdvisorRatingUseCase;
